$(document).ready(function(){
  
  $('a.button').on('click', function(e){
    if(typeof $(this).data('pt_cta_id') != "undefined" && $(this).data('pt_cta_id') != "") {
      
      e.preventDefault();      
      const pt_cta_id = $(this).data('pt_cta_id');
      pSendGAEvent('pt_cta_click', { pt_cta_id: pt_cta_id}, 'content_ctatracking.js', 'tracking send event gone wrong');
      window.location = $(this).attr('href');
    }
        
  });
  
  
});